// Mock data — sized to feel real, not exhaustive.
// All prices/probabilities expressed as percentages 0..100.

export const VENUES = ['Polymarket', 'Kalshi', 'PrizePicks', 'DraftKings', 'BetOnline', 'Deribit'];

export const TOPICS = [
  { id: 'politics',  label: 'US Politics',     count: 412 },
  { id: 'nba',       label: 'NBA Playoffs',    count: 248 },
  { id: 'crypto',    label: 'Crypto',          count: 186 },
  { id: 'macro',     label: 'Fed & Macro',     count: 92  },
  { id: 'ai',        label: 'AI Regulation',   count: 64  },
  { id: 'culture',   label: 'Culture',         count: 78  },
  { id: 'sports',    label: 'Sports Props',    count: 511 },
  { id: 'geopol',    label: 'Geopolitics',     count: 41  },
  { id: 'weather',   label: 'Weather',         count: 28  },
  { id: 'science',   label: 'Science',         count: 19  },
];

export const SIGNALS = [
  {
    id: 'sig-001',
    market: 'Will Trump win the 2024 Presidential Election?',
    venue: 'Polymarket',
    topic: 'politics',
    subtopic: 'Presidential winner',
    marketPct: 51,
    fairPct: 58,
    edgePct: 7.0,
    confidence: 76,
    confLow: 70, confHigh: 82,
    liquidity: '$12.4M',
    liquidityScore: 92,
    volume24: '$842k',
    timeLeft: '195d',
    rulesRisk: 'Low',
    catalyst: 'Debate · 3d',
    socialConv: 71,
    tier: 'standard',
    status: 'NEW',
    spark: [42, 44, 47, 46, 49, 51, 53, 51, 50, 52, 54, 56, 55, 57, 58],
    traders: { taking: 12, skipping: 3, fading: 2 },
    thesis: 'Polling stabilization + structural Senate map favors GOP turnout. Quantzy model weights debate volatility & state-by-state polling shifts.',
  },
  {
    id: 'sig-002',
    market: 'OKC to win Game 5 vs Mavericks',
    venue: 'PrizePicks',
    topic: 'nba',
    subtopic: 'Series · G5',
    marketPct: 64,
    fairPct: 73,
    edgePct: 9.0,
    confidence: 81,
    confLow: 76, confHigh: 86,
    liquidity: '$1.8M',
    liquidityScore: 64,
    volume24: '$412k',
    timeLeft: '6h',
    rulesRisk: 'Low',
    catalyst: 'Tip-off · 6h',
    socialConv: 84,
    tier: 'standard',
    status: 'MOVING',
    spark: [50, 52, 55, 58, 56, 60, 63, 64, 66, 68, 70, 71, 73, 72, 73],
    traders: { taking: 18, skipping: 4, fading: 1 },
    thesis: 'Home advantage + injury report tilt + pace mismatch. 2024 home G5 win-rate at 78% league-wide. Lineup adjustment improves rim defense by ~6%.',
  },
  {
    id: 'sig-003',
    market: 'Bitcoin closes above $100k by July 31',
    venue: 'Kalshi',
    topic: 'crypto',
    subtopic: 'Spot price band',
    marketPct: 38,
    fairPct: 52,
    edgePct: 14.0,
    confidence: 68,
    confLow: 60, confHigh: 76,
    liquidity: '$4.2M',
    liquidityScore: 78,
    volume24: '$1.1M',
    timeLeft: '94d',
    rulesRisk: 'Medium',
    catalyst: 'Halving cycle · ongoing',
    socialConv: 62,
    tier: 'apex',
    status: 'CONFIRMED',
    spark: [22, 25, 28, 30, 33, 30, 32, 36, 38, 40, 42, 45, 48, 50, 52],
    traders: { taking: 9, skipping: 11, fading: 3 },
    thesis: 'Apex signal · Spot-ETF flow regime + post-halving supply pressure. Composite conviction lifted by 8.4% via top-decile trader confirmation.',
  },
  {
    id: 'sig-004',
    market: 'Fed cuts rates by 25bps at June meeting',
    venue: 'Kalshi',
    topic: 'macro',
    subtopic: 'FOMC',
    marketPct: 28,
    fairPct: 22,
    edgePct: 6.0,
    confidence: 71,
    confLow: 64, confHigh: 78,
    liquidity: '$3.6M',
    liquidityScore: 84,
    volume24: '$680k',
    timeLeft: '38d',
    rulesRisk: 'Low',
    catalyst: 'CPI · 9d',
    socialConv: 58,
    tier: 'standard',
    status: 'NEW',
    spark: [44, 42, 40, 38, 36, 34, 32, 30, 28, 28, 26, 24, 23, 22, 22],
    fade: true,
    traders: { taking: 6, skipping: 8, fading: 14 },
    thesis: 'Fade signal · Sticky core services inflation + restrictive language in last minutes. Market overpricing dovish pivot probability.',
  },
  {
    id: 'sig-005',
    market: 'EU AI Act delegated rules finalized by Q3',
    venue: 'Polymarket',
    topic: 'ai',
    subtopic: 'Policy',
    marketPct: 41,
    fairPct: 48,
    edgePct: 7.0,
    confidence: 64,
    confLow: 55, confHigh: 73,
    liquidity: '$280k',
    liquidityScore: 38,
    volume24: '$42k',
    timeLeft: '162d',
    rulesRisk: 'High',
    catalyst: 'Trilogue · 28d',
    socialConv: 52,
    tier: 'apex',
    status: 'NEW',
    spark: [30, 32, 34, 35, 37, 38, 40, 41, 41, 43, 44, 45, 46, 47, 48],
    traders: { taking: 4, skipping: 10, fading: 2 },
    thesis: 'Apex signal · Watch for resolution-rule ambiguity. Model penalizes confidence by 12% for definitional risk on "finalized" language.',
  },
  {
    id: 'sig-006',
    market: 'Lakers eliminated before conf finals',
    venue: 'PrizePicks',
    topic: 'nba',
    subtopic: 'Series outcome',
    marketPct: 78,
    fairPct: 71,
    edgePct: 7.0,
    confidence: 73,
    confLow: 67, confHigh: 79,
    liquidity: '$640k',
    liquidityScore: 52,
    volume24: '$210k',
    timeLeft: '14d',
    rulesRisk: 'Low',
    catalyst: 'G6 · 2d',
    socialConv: 41,
    tier: 'standard',
    status: 'CONTRARIAN',
    fade: true,
    spark: [62, 65, 68, 71, 73, 75, 76, 78, 78, 76, 74, 73, 72, 71, 71],
    traders: { taking: 7, skipping: 6, fading: 9 },
    thesis: 'Contrarian fade · Crowd overreacting to G3 blowout. Pace-adjusted efficiency favors LAL when starting lineup intact.',
  },
  {
    id: 'sig-007',
    market: 'CPI YoY prints below 3.2% in May',
    venue: 'Kalshi',
    topic: 'macro',
    subtopic: 'Inflation',
    marketPct: 56,
    fairPct: 64,
    edgePct: 8.0,
    confidence: 74,
    confLow: 67, confHigh: 81,
    liquidity: '$2.1M',
    liquidityScore: 72,
    volume24: '$320k',
    timeLeft: '9d',
    rulesRisk: 'Low',
    catalyst: 'BLS print · 9d',
    socialConv: 67,
    tier: 'standard',
    status: 'MOVING',
    spark: [48, 50, 52, 54, 56, 56, 58, 60, 60, 61, 62, 62, 63, 63, 64],
    traders: { taking: 22, skipping: 4, fading: 2 },
    thesis: 'Shelter component cooling + base effects. Nowcast model from regional Fed indicators favors below-consensus.',
  },
  {
    id: 'sig-008',
    market: 'TikTok divestiture deal announced before Sept',
    venue: 'Polymarket',
    topic: 'politics',
    subtopic: 'Tech policy',
    marketPct: 22,
    fairPct: 18,
    edgePct: 4.0,
    confidence: 58,
    confLow: 50, confHigh: 66,
    liquidity: '$1.4M',
    liquidityScore: 66,
    volume24: '$118k',
    timeLeft: '128d',
    rulesRisk: 'Medium',
    catalyst: 'Court ruling · 41d',
    socialConv: 48,
    tier: 'standard',
    status: 'NEW',
    fade: true,
    spark: [30, 28, 28, 26, 25, 24, 23, 23, 22, 22, 21, 20, 20, 19, 18],
    traders: { taking: 3, skipping: 9, fading: 5 },
    thesis: 'Fade · Procedural delays + injunction probability. Market underpricing legal calendar friction.',
  },
  {
    id: 'sig-009',
    market: 'Taylor Swift announces tour extension by July',
    venue: 'Polymarket',
    topic: 'culture',
    subtopic: 'Music',
    marketPct: 34,
    fairPct: 47,
    edgePct: 13.0,
    confidence: 62,
    confLow: 53, confHigh: 71,
    liquidity: '$180k',
    liquidityScore: 28,
    volume24: '$24k',
    timeLeft: '74d',
    rulesRisk: 'High',
    catalyst: 'Album promo · ongoing',
    socialConv: 73,
    tier: 'apex',
    status: 'NEW',
    spark: [22, 24, 27, 30, 32, 34, 36, 38, 40, 42, 43, 45, 46, 47, 47],
    traders: { taking: 5, skipping: 14, fading: 1 },
    thesis: 'Apex · Booking pattern + venue-hold leak data. Resolution-rule risk: definition of "tour extension" not strict.',
  },
  {
    id: 'sig-010',
    market: 'NHC names tropical system in Atlantic by June 15',
    venue: 'Kalshi',
    topic: 'weather',
    subtopic: 'Hurricane',
    marketPct: 45,
    fairPct: 58,
    edgePct: 13.0,
    confidence: 70,
    confLow: 62, confHigh: 78,
    liquidity: '$340k',
    liquidityScore: 42,
    volume24: '$58k',
    timeLeft: '48d',
    rulesRisk: 'Low',
    catalyst: 'SST anomaly · ongoing',
    socialConv: 60,
    tier: 'standard',
    status: 'NEW',
    spark: [30, 33, 36, 39, 42, 45, 47, 49, 51, 52, 54, 55, 56, 57, 58],
    traders: { taking: 11, skipping: 6, fading: 2 },
    thesis: 'Above-average SSTs in MDR + early MJO phase. Climatology + nowcast composite favors named system before mid-June.',
  },
  {
    id: 'sig-011',
    market: 'Spot Solana ETF approved before year-end',
    venue: 'Polymarket',
    topic: 'crypto',
    subtopic: 'Regulatory',
    marketPct: 31,
    fairPct: 42,
    edgePct: 11.0,
    confidence: 66,
    confLow: 58, confHigh: 74,
    liquidity: '$2.8M',
    liquidityScore: 76,
    volume24: '$480k',
    timeLeft: '247d',
    rulesRisk: 'Medium',
    catalyst: 'SEC docket · 60d',
    socialConv: 64,
    tier: 'apex',
    status: 'CONFIRMED',
    spark: [22, 24, 26, 28, 30, 31, 33, 35, 37, 38, 40, 41, 42, 42, 42],
    traders: { taking: 14, skipping: 8, fading: 3 },
    thesis: 'Apex · Post-BTC/ETH precedent + filing cadence. Composite conviction +9% from top-decile crypto traders.',
  },
  {
    id: 'sig-012',
    market: 'Knicks +5.5 Game 6 vs Pacers',
    venue: 'DraftKings',
    topic: 'sports',
    subtopic: 'Spread',
    marketPct: 52,
    fairPct: 61,
    edgePct: 9.0,
    confidence: 79,
    confLow: 73, confHigh: 85,
    liquidity: '$3.4M',
    liquidityScore: 80,
    volume24: '$1.2M',
    timeLeft: '22h',
    rulesRisk: 'Low',
    catalyst: 'Tip-off · 22h',
    socialConv: 78,
    tier: 'standard',
    status: 'MOVING',
    spark: [45, 47, 49, 50, 51, 52, 53, 55, 57, 58, 59, 60, 61, 61, 61],
    traders: { taking: 24, skipping: 5, fading: 2 },
    thesis: 'Pace differential + injury report adjustment. Closing-line value in 87th percentile of similar season-long lookups.',
  },
];

export const MISSED = [
  {
    id: 'miss-1',
    market: 'Bitcoin > $70k by April 1',
    interactedOn: '2026-03-12',
    action: 'searched, did not act',
    edgeAtTime: 12.4,
    moveCents: 31,
    potentialProfit: '$1,840',
    reason: 'No alert set',
    tier: 'standard',
  },
  {
    id: 'miss-2',
    market: 'Senate D win majority',
    interactedOn: '2026-04-02',
    action: 'watched, dismissed',
    edgeAtTime: 8.1,
    moveCents: 18,
    potentialProfit: '$760',
    reason: 'Below confidence threshold',
    tier: 'standard',
  },
  {
    id: 'miss-3',
    market: 'Apple earnings beat by >5%',
    interactedOn: '2026-04-18',
    action: 'searched',
    edgeAtTime: 9.7,
    moveCents: 22,
    potentialProfit: '$1,210',
    reason: 'Apex-locked branch',
    tier: 'apex',
  },
  {
    id: 'miss-4',
    market: 'NBA total points G2 over 224.5',
    interactedOn: '2026-04-22',
    action: 'clicked, skipped',
    edgeAtTime: 6.2,
    moveCents: 12,
    potentialProfit: '$340',
    reason: 'Liquidity filter strict',
    tier: 'standard',
  },
  {
    id: 'miss-5',
    market: 'EU passes platform regulation',
    interactedOn: '2026-04-10',
    action: 'almost acted',
    edgeAtTime: 11.0,
    moveCents: 27,
    potentialProfit: '$1,120',
    reason: 'Catalyst alert disabled',
    tier: 'standard',
  },
  {
    id: 'miss-6',
    market: 'NHC names Alex by June 1',
    interactedOn: '2026-04-25',
    action: 'searched',
    edgeAtTime: 13.0,
    moveCents: 16,
    potentialProfit: '$520',
    reason: 'No niche set',
    tier: 'apex',
  },
];

export const TRADERS = [
  { name: 'kaldera',     specialty: 'Macro & Fed',     hit: 71, roi: 18.4, brier: 0.142, calib: 96, samples: 612, followers: 4820, tier: 'Apex',     streak: '12W', drawdown: 4.2 },
  { name: 'fadeking',    specialty: 'Crowd fades',     hit: 64, roi: 11.2, brier: 0.158, calib: 92, samples: 482, followers: 3110, tier: 'Platinum', streak: '7W',  drawdown: 7.8 },
  { name: 'oddsoracle',  specialty: 'NBA props',       hit: 68, roi:  9.8, brier: 0.166, calib: 88, samples: 904, followers: 2740, tier: 'Gold',     streak: '5W',  drawdown: 6.1 },
  { name: 'macroprint',  specialty: 'CPI / payrolls',  hit: 73, roi:  7.1, brier: 0.151, calib: 94, samples: 218, followers: 1980, tier: 'Platinum', streak: '4W',  drawdown: 3.4 },
  { name: 'rulesriskQ',  specialty: 'Resolution rules', hit: 78, roi: 12.6, brier: 0.138, calib: 97, samples: 364, followers: 5210, tier: 'Apex',     streak: '9W',  drawdown: 2.1 },
  { name: 'gridsearch',  specialty: 'AI policy',       hit: 62, roi:  6.3, brier: 0.171, calib: 86, samples: 142, followers: 1240, tier: 'Gold',     streak: '3W',  drawdown: 5.6 },
  { name: 'darkpool88',  specialty: 'Crypto ETFs',     hit: 66, roi: 14.7, brier: 0.149, calib: 91, samples: 510, followers: 3680, tier: 'Apex',     streak: '11W', drawdown: 8.4 },
  { name: 'thresholdQ',  specialty: 'Confidence band', hit: 70, roi:  8.4, brier: 0.146, calib: 95, samples: 821, followers: 2110, tier: 'Platinum', streak: '6W',  drawdown: 4.0 },
  { name: 'closing-line',specialty: 'Sports CLV',      hit: 64, roi: 10.2, brier: 0.162, calib: 89, samples: 1240, followers: 4090, tier: 'Apex',    streak: '14W', drawdown: 5.5 },
  { name: 'catalysthunt',specialty: 'Event windows',   hit: 67, roi:  7.9, brier: 0.155, calib: 90, samples: 304, followers: 1530, tier: 'Gold',     streak: '4W',  drawdown: 4.7 },
];

export const TEAMS = [
  { name: 'Apex Macro',        captain: 'kaldera',    members: 84,  hit: 72, roi: 14.2, focus: 'Fed, CPI, Payrolls' },
  { name: 'Hardwood Quants',   captain: 'oddsoracle', members: 142, hit: 66, roi:  9.4, focus: 'NBA props, totals' },
  { name: 'Crypto Edge Lab',   captain: 'darkpool88', members: 68,  hit: 67, roi: 12.8, focus: 'ETF flow, halving' },
  { name: 'Rules Lawyers',     captain: 'rulesriskQ', members: 39,  hit: 76, roi: 11.0, focus: 'Resolution clarity' },
  { name: 'Catalyst Calendar', captain: 'catalysthunt', members: 92, hit: 64, roi:  8.2, focus: 'Event-window arb' },
];

// Calibration buckets (predicted vs actual).
export const CALIB = [
  { bucket: '50–60%', n: 412, predicted: 55.0, actual: 53.8 },
  { bucket: '60–70%', n: 528, predicted: 65.2, actual: 64.4 },
  { bucket: '70–80%', n: 612, predicted: 74.8, actual: 75.6 },
  { bucket: '80–90%', n: 388, predicted: 84.6, actual: 83.2 },
  { bucket: '90%+',   n: 142, predicted: 92.4, actual: 91.0 },
];

export const CATEGORIES = [
  { topic: 'NBA Playoffs', edge: 9.4, hit: 71, samples: 812, color: '#2563EB' },
  { topic: 'US Politics',  edge: 6.8, hit: 68, samples: 1240, color: '#1E40AF' },
  { topic: 'Crypto',       edge: 11.2, hit: 64, samples: 642, color: '#7C5CFF' },
  { topic: 'Macro',        edge: 7.1, hit: 73, samples: 412, color: '#00BFA6' },
  { topic: 'AI',           edge: 5.4, hit: 62, samples: 184, color: '#C9A24B' },
  { topic: 'Culture',      edge: 4.9, hit: 60, samples: 96, color: '#9AA3AE' },
  { topic: 'Weather',      edge: 8.2, hit: 67, samples: 142, color: '#10B981' },
];

export const CATALYSTS = [
  { when: 'Today · 18:00 UTC', label: 'NBA G5 OKC vs DAL', topic: 'nba', impact: 'High',   markets: 18 },
  { when: 'Tomorrow · 13:30',  label: 'CPI YoY print',     topic: 'macro', impact: 'High', markets: 14 },
  { when: 'Fri · 14:00',       label: 'Presidential debate', topic: 'politics', impact: 'High', markets: 22 },
  { when: 'Mon · 09:00',       label: 'EU AI Act trilogue',  topic: 'ai',    impact: 'Med',  markets: 7  },
  { when: 'Wed · resolution',  label: 'NHC season opener',   topic: 'weather', impact: 'Low', markets: 4  },
  { when: 'Thu · 20:00',       label: 'SEC SOL ETF docket',  topic: 'crypto', impact: 'Med', markets: 9 },
];

export function getSignal(id) {
  return SIGNALS.find((s) => s.id === id) || SIGNALS[0];
}
